module.exports = __webpack_public_path__ + "static/media/gritag_1.84b89e57.jpeg";